import { VendorTaxonomyKey } from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { getVendorTaxonomyId } from '@zola-helpers/client/dist/es/marketplace/vendorUtils';
import { StorefrontCardView } from '@zola/svc-marketplace-ts-types';

import queryString from 'query-string';

import {
  NUM_TOP_PICKS,
  topPicksFilter,
} from '~/pages/couples/explore/components/SearchResults/components/TopPicks/topPicksConstants';
import ApiService from '~/util/apiService';

export const fetchTopPicks = ({
  taxonomyKey,
  vendorMarketId,
}: {
  taxonomyKey: VendorTaxonomyKey;
  vendorMarketId: number | null;
}): Promise<StorefrontCardView[]> => {
  const taxonomyNodeId = getVendorTaxonomyId(taxonomyKey);

  return ApiService.get<StorefrontCardView[]>(
    `/web-marketplace-api/v3/storefront/top-picks?taxonomy_node_id=${taxonomyNodeId}&offset=0&limit=${NUM_TOP_PICKS}&fallback_vendor_market_id=${vendorMarketId}`
  ).then(topPicksFilter);
};

export const fetchRecentlyViewed = ({
  taxonomyKey,
  vendorMarketId,
}: {
  taxonomyKey: VendorTaxonomyKey | undefined;
  vendorMarketId: number | null;
}) => {
  const request = queryString.stringify({
    vendor_market_id: vendorMarketId,
    taxonomy_node_id: taxonomyKey ? getVendorTaxonomyId(taxonomyKey) : null,
    limit: 10,
    allow_unclaimed_listings: false,
  });

  return ApiService.get<StorefrontCardView[]>(
    `/web-marketplace-api/v2/recently-viewed/storefronts?${request}`
  );
};
